import { Button, Modal, Form, Row, Col, Input } from "antd";
import { useState } from "react";
import updateModel from "../../../../services/updateModel";
import getBase64 from "../../../../utils/getBase64";

const { TextArea } = Input;

export default function UpdateModel({ isVisible, hideModal, selected }: any) {
  const [isSelected, setIsSelected] = useState(false);
  const [selectedFile, setSelectedFile]: any = useState();

  const [form] = Form.useForm();

  const onSubmit = async () => {
    const { link } = await form.validateFields();
    // const base64 = await getBase64(selectedFile);
    const data = { image: link };
    const model_id = selected?._id;
    await updateModel({
      data,
      model_id,
    });
    hideModal();
    form.resetFields();
  };

  const clearForm = async () => {
    form.resetFields();
  };

  const changeHandler = (event: any) => {
    setSelectedFile(event.target.files[0]);
    setIsSelected(true);
  };

  return (
    <Modal
      visible={isVisible}
      title={`UPDATE ${selected?.name}`}
      onCancel={hideModal}
      footer={[
        <Button danger key="back" onClick={clearForm}>
          Clear
        </Button>,
        <Button
          key="submit"
          form="updateModel"
          htmlType="submit"
          type="primary"
          onSubmit={onSubmit}
          // loading={isLoading}
          danger
        >
          Submit
        </Button>,
      ]}
    >
      <Form
        id="AddDocument"
        form={form}
        name="normal_login"
        className="login-form"
        onFinish={onSubmit}
      >
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 24 }}>
            <Form.Item
              name="link"
              initialValue={selected?.name}
              rules={[
                {
                  required: true,
                  message: "Please enter link",
                },
              ]}
            >
              <Input placeholder="Image Url" />
            </Form.Item>
          </Col>
          {/* <Col xs={{ span: 24 }} lg={{ span: 24 }}>
            <Form.Item
              name="file"
              rules={[
                {
                  required: true,
                  message: "Please select file",
                },
              ]}
            >
              <Input
                type="file"
                placeholder="Document"
                onChange={changeHandler}
              />
            </Form.Item>
          </Col> */}
        </Row>
        <button onClick={onSubmit}>Click</button>
        {isSelected ? (
          <div>
            <p>Filename: {selectedFile?.name}</p>
            <p>Size : {selectedFile?.size / 1000} kb</p>
          </div>
        ) : null}
      </Form>
    </Modal>
  );
}
